import type { TooltipPropSize, Direction, TooltipPropStatus } from 'uikit';
import { Tooltip } from 'uikit';

import type { CSSProperties, FC, ReactElement } from 'react';
import { useCallback, useRef, useState } from 'react';

export const ComponentWithTooltip: FC<{
    tooltipText: string | ReactElement | null | undefined;
    status?: TooltipPropStatus;
    size?: TooltipPropSize;
    direction?: Direction;
    className?: string;
    styles?: CSSProperties;
    isAlwaysVisible?: boolean;
}> = ({
    children,
    tooltipText,
    status,
    size = 'm',
    direction = 'upCenter',
    styles,
    className,
    isAlwaysVisible = false,
}) => {
    const Ref = useRef(null);
    const [isOpenTooltip, setIsOpenTooltip] = useState<boolean>(false);

    const handleMouseMoveButton = useCallback(() => {
        setIsOpenTooltip(true);
    }, []);

    const handleMouseLeaveButton = useCallback(() => {
        setIsOpenTooltip(false);
    }, []);

    return (
        <>
            <div
                ref={Ref}
                onMouseMove={handleMouseMoveButton}
                onMouseLeave={handleMouseLeaveButton}
                style={styles}
                className={className}
            >
                {children}
            </div>
            {tooltipText && (isOpenTooltip || isAlwaysVisible) && (
                <Tooltip
                    style={{ wordBreak: 'break-word' }}
                    size={size}
                    direction={direction}
                    anchorRef={Ref}
                    isInteractive={false}
                    status={status}
                >
                    {tooltipText}
                </Tooltip>
            )}
        </>
    );
};

ComponentWithTooltip.displayName = 'ComponentWithTooltip';
